import {OrderDetailComponent} from "./order-detail.component";

export default OrderDetailComponent